import React from "react";
import style from "./line.module.scss";

const Line = () => {
  return <div className={style.line}></div>;
};

export default Line;
